import PropTypes from 'prop-types';
import ButtonLink from 'sd-ui/dist/commonjs/components/ButtonLink/ButtonLink';
import { useCallback, useContext } from 'react';
import PanelContext from '../sidebar/panel/panelContext';
import { createAssetLink } from '../../utils/linkCreator';
import { panelType, referenceType as referenceTypeConstant } from '../../../shared/constants';
import getPdfViewerApplication from '../../utils/pdfjs/pdfViewerApplication';

const referenceType = referenceTypeConstant.figure;

const { enhancementManager } = getPdfViewerApplication();

export default function FigureThumbnail({ figure }) {
  const { openPanel } = useContext(PanelContext);

  const openReference = useCallback(async () => {
    await enhancementManager.setActiveReferenceId(referenceType, figure.id);
    openPanel({ component: panelType.figure });
  }, [openPanel, figure]);

  return (
    <li className="figure-thumbnail" key={figure.id}>
      <ButtonLink
        className="u-text-left"
        icon={null}
        onClick={openReference}
      >
        <img
          alt={figure.label}
          src={createAssetLink(figure.figure.small)}
        />
        {figure.label}
      </ButtonLink>
    </li>
  );
}

FigureThumbnail.propTypes = {
  figure: PropTypes.shape({
    figure: PropTypes.shape({ small: PropTypes.string }),
    id: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
};
